//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const response = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getResponse(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/response?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function createResponse(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/response`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function updateResponse(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/response`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }
  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/response/search?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getResponse,
    createResponse,
    updateResponse,
    searchAPI
  };
};

export default response;
